import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class OnlineOrderServiceTypeService {
    constructor(private http: AuthHttp) { }

    GetServiceTypes() {
        return this.http.get(AppSettings.apiEndpoint + 'OnlineOrderServiceType/GetServiceTypes')
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/online-order-service-type.service.ts